import * as yup from 'yup'
import { trimString } from 'common/utils/yupSchemaUtils'

export const schema = yup
  .object({
    name: yup
      .string()
      .required('Collection name required')
      .min(4, 'Collection name must be at least 4 characters')
      .max(30, 'Collection name must be under 30 characters')
      .transform(trimString),
    subtitle: yup.string().max(60, 'Subtitle must be under 60 characters'),
    description: yup.string().max(600, 'Description must be under 600 characters'),
    color: yup.string(),
    previewImg: yup.string(),
  })
  .required()
